import { useContext } from "react";
import { EditOnboardingContext } from "../contexts/EditOnboardingContext";

export function useEditOnboarding() {
  const value = useContext(EditOnboardingContext);
  return value;
}
